module.exports = __webpack_public_path__ + "media/images/crypto-currencies/icon-9d13af2a8525ef0be1e035537b239f74.svg";